/* IMPORT */
import { lazyArrayPush } from '../lazy.js';
import Observer from './observer.js';
import Scheduler from './scheduler.async.js';
import { SYMBOL_SUSPENSE } from '../symbols.js';
import { isFunction } from '../utils.js';
import { callStack, Stack } from '../methods/debugger.js';
/* MAIN */
class Effect extends Observer {
    /* CONSTRUCTOR */
    constructor(fn, options) {
        super();
        this.fn = fn;
        if (options?.suspense !== false) {
            const suspense = this.get(SYMBOL_SUSPENSE);
            if (suspense) {
                this.suspense = suspense;
            }
        }
        if (options?.sync === true) {
            this.sync = true;
        }
        const { stack } = options ?? { stack: callStack('Effect init') };
        if (options?.sync === 'init') {
            this.init = true;
            this.update(stack);
        }
        else {
            this.schedule(stack);
        }
    }
    /* API */
    run(stack) {
        const result = super.refresh(this.fn, stack);
        if (isFunction(result)) {
            lazyArrayPush(this, 'cleanups', result);
        }
    }
    schedule(stack) {
        if (this.suspense?.suspended)
            return;
        if (this.sync) {
            this.update(stack);
        }
        else {
            Scheduler.schedule(this, stack);
        }
    }
    stale(status, stack) {
        const statusPrev = this.status;
        if (statusPrev >= status)
            return;
        this.status = status;
        if (!this.sync || (statusPrev !== 2 && statusPrev !== 3)) { // It isn't currently executing, so let's schedule it
            this.schedule(stack);
        }
    }
    update(stack) {
        if (this.suspense?.suspended)
            return;
        super.update(stack);
    }
}
/* EXPORT */
export default Effect;
